import React, { Component } from "react";

export default class FadedPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.fade = false;
    this.fadingDone = this.fadingDone.bind(this);
  }

  setFade(fading) {
    this.setState({ fade: fading });
    setTimeout(this.fadingDone.bind(this), 1200);
  }

  fadingDone() {
    // will re-render component, removing the animation class
    this.setState({ fade: false });
  }
  render() {
    return (
      <div
        className={
          this.state.fade || this.props.fade
            ? "ser-overlayPanel ser-overlayAnimate"
            : "ser-overlayPanel"
        }
        aria-label="Anzeigetext beim Hinzufügen zum Warenkorb"
      >
        <span className="ser-iblock ser-overlayText">
          erfolgreich hinzugefügt
        </span>
        <div className="icon icon-checked ser-overlayCheck"></div>
      </div>
    );
  }
}
